<template>
  <Page :title="title" class="remark">
    <div>
      <div class="content">
        <div class="name">活动名称</div>
        <div class="table">{{campMember.campName}}</div>
        <!-- 轮播图 -->
        <div class="swaper">
          <van-swipe :autoplay="3000" style="width: 100%;height: 100%;">
            <van-swipe-item
              v-for="(image, index) in images"
              :key="index"
              @click="ImagePreview(index)"
            >
              <img :src="image" style="width: 100%;height: 100%;">
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="appraise">
        <span class="appraise_ico"></span> 点评
      </div>
      <!-- 五角星 -->
      <div class="stars_content">
        <van-row>
          <van-col span="12" class="appraise_person">{{campMember.reviewUserName||'点评人'}}</van-col>
          <van-col span="12">
            <van-rate
              :value="campMember.U_ReviewScore"
              :count="count"
              :readonly="false"
              style="text-align: center;"
              class="stars"
              color="#E10913"
              @change="changeRate"
            />
          </van-col>
        </van-row>
        <van-field
          class="textarea"
          type="textarea"
          placeholder="请输入备注内容描述"
          rows="3"
          autosize
          v-model="campMember.U_Review"
        />
        <van-row>
          <van-col span="24" class="appraise_time">
            <van-icon class="icon" name="underway-o"/>{{campMember.reviewTime}}
          </van-col>
        </van-row>
      </div>
      <!-- 底部按钮 -->
      <div class="bottom-btn flex" v-if="$wxuserUtil.hasFunAuth(menuId,$wxuserUtil.funcKey.ReviewCreated,true,'无点评权限')">
        <div class="item1 btn save" @click="back">返回</div>
        <div class="item1 btn sub" @click="sub" v-if="!campMember.reviewUser">提交</div>
      </div>
    </div>
  </Page>
</template>




<script>
  //imgList 客户作品图片列表  courseMember 课程成员对象
  // accountId	//用户id
  // name	//课程名称
  // reviewScore	//评分
  // review	//评价
  // courseId	//课程id

  // U_StaticResorurceId	//资源ID
  // U_url	//图片路径
  // U_Sort	//排序
  import $api from "../../api/lkcollege_api"; // 接口
  import { Dialog, Toast, Notify, ImagePreview } from "vant";
  export default {
    data() {
      return {
        count: 5, //星星总数
        title: "查看作品",
        images: [
          "https://img.yzcdn.cn/2.jpg",
          "https://img.yzcdn.cn/2.jpg",
          "https://img.yzcdn.cn/2.jpg",
          "https://img.yzcdn.cn/2.jpg"
        ],
        campMember: {
          reviewScore: 3
        },
        menuId : ''
      };
    },
    watch:{
        'campMember.U_ReviewScore':(newVal,oldVal)=>{
            if(newVal==oldVal){
                this.campMember.U_ReviewScore = oldVal-1
            }
        }
    },
    methods: {
      //返回
      back() {
        this.$router.back(1);
      },
      //切换图片
      ImagePreview(index) {
        console.log(index);
        ImagePreview({
          showIndicators: true,
          images: this.images,
          startPosition: index
        });
      },
      //客户课程作品详情接口
      async detailWorks() {
        try {
          let data = this.$api.$active.campaignDetailWorks({
              salesId:this.$wxuserUtil.getUserId(),
               campMemberId:this.$route.query.id
          }).then(data=>{
            //查询失败
            if (!data.success) {
              this.$title(data.msg);
              return;
            }
            let { campMember, imgList } = data.data;
            this.campMember = campMember;
            //处理图片
            let newimgList = [];
            for (const iterator of imgList) {
              newimgList.push(`${this.$http}upload/${iterator.U_url}`);
            }
            this.images = newimgList;
          })

        } catch (error) {
          console.log(error);
          this.$title("发生错误");
        }
      },
      sub(){
         this.$api.$active.campaignSaveWorksReview({
           salesId:this.$wxuserUtil.getUserId(),
           'pojo.id':this.$route.query.id,
           'pojo.review':this.campMember.U_Review,
           'pojo.reviewScore':this.campMember.U_ReviewScore,
         }).then(response=>{
           if(response.success==true){
             this.$router.back(1);
           }else{
             this.$title(`点评失败,${response.msg}`);
           }
         })
      },
      changeRate(e){
         if(this.campMember.U_ReviewScore==e){
           this.campMember.U_ReviewScore = this.campMember.U_ReviewScore-1
         }else{
           this.campMember.U_ReviewScore =e
         }
      }
    },
    mounted() {
      this.menuId = this.$route.query.menuId;
    },
    watch: {},
    created() {
     this.detailWorks()
    },
    components: {}
  };
</script>

<style lang="less"  scoped>
  .content {
    background: white;
    padding: 0.5rem;
  }
  .name {
    font-weight: 600;
    color: #9c9c9c;
    text-align: left;
    font-size: 14px;
  }
  .table {
    color: #2d2d2d;
    font-weight: bold;
    text-align: left;
    font-size: 18px;
  }
  .appraise {
    padding: 0.5rem;
  }
  .appraise_person,
  .appraise {
    color: #2d2d2d;
    font-weight: bold;
    text-align: left;
    font-size: 15px;
  }
  .appraise_text {
    color: #777777;
    font-size: 13px;
    padding: 0.1rem;
    white-space: normal;
    word-break: break-all;
  }
  .appraise_time {
    color: #979797;
    font-size: 12px;
    padding: 0.1rem;
  }
  .appraise_time .icon{
    position: relative;
    top:1px;
    margin-right: 2px;
  }
  .appraise_ico {
    width: 0.1rem;
    height: 0.4rem;
    background-color: #e10913;
    display: inline-block;
  }
  .listcontent {
  // margin: 0.5rem 0.5rem 0rem 0.5rem;
  // background: white;
  // height: 40px;
  // border: 1px solid rgba(167, 167, 167, 1);
  }
  .itemrow,
  .itemvalue {
    height: 100%;
  // text-align: center;
    padding-left: 0.1rem;
    line-height: 40px;
  }
  .van-field__control {
    display: inline-block;
    height: 40px;
    border: none;
  }
  .bottom_btn {
    position: fixed;
    bottom: 0rem;
    width: 100%;
  // margin: 0 auto;
    text-align: center;
  // height: 2rem;
  // display: flex;
  // flex-direction: row;
  // justify-content: space-between;
  // padding-bottom: 0.3rem;
  // background-color: rgba(255, 255, 255, 1);
  }
  .bottom_btn1 {
    margin: 0 auto;
    width: 100%;
    height: 1.5rem;
    border-radius: 4px;
    line-height: 40px;
    background-color: #222222;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    font-family: Microsoft Yahei;
  // border: 1px solid rgba(229, 28, 35, 1);
    font-weight: bold;
  }
  .swaper {
    width: 90%;
    margin: 1rem auto;
    height: 160px;
    line-height: 23px;
    border-radius: 3px 3px 3px 3px;
    background-color: rgba(184, 232, 128, 1);
    color: rgba(13, 13, 13, 1);
    font-size: 16px;
    text-align: center;
    box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 1);
    font-family: Arial;
  }
  .stars_content {
    width: 95%;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
  // text-align: center;
  // margin-top: 1rem;
    height: 4rem;
  // border: 1px solid rgba(167, 167, 167, 1);
    padding: 0.3rem;
    box-sizing: border-box;
    font-size: 13px;
  }
  .van-rate__item {
    color: #e10913;
  }
  .stars_text {
    text-align: center;
    width: 100%;
    height: 61px;
    color: rgba(13, 13, 13, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-regular;
  }
 .remark .textarea {
    width:100%;
    padding:0;
  }
  .bottom-btn{
    height:46px;
    line-height: 46px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    position: fixed;
    left:0;
    right:0;
    bottom:0
  }
  .bottom-btn .save{
    background-color: #222;
  }
  .bottom-btn .sub{
    background-color: #E10913;
  }

</style>



// WEBPACK FOOTER //
// src/components/active/activeRemark.vue